import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './recruitment.module.scss';
import processImg02 from '../../img/Telus_One_page-02.png';
import processImg03 from '../../img/Telus_One_page-03.png';
import processImg04 from '../../img/Telus_One_page-04.png';
import processImg05 from '../../img/Telus_One_page-05.png';
import processImg06 from '../../img/Telus_One_page-06.png';
import processImg07 from '../../img/Telus_One_page-07.png';
import processImg08 from '../../img/Telus_One_page-08.png';
import processImg09 from '../../img/Telus_One_page-09.png';

let cx = classNames.bind(styles);

const Recruitment = () => {
	const { t } = useTranslation();

	return (
		<section id='how-to-apply' className={cx({ recruitment: true })}>
			<div className='container flex flex-col w-full mx-auto justify-center items-center'>
				<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-4xl px-4 text-center lg:py-4'>
					<span className='text-telus-dark'>How TELUS International</span> remote recruitment works
				</h1>
				<div className="flex flex-col lg:flex-row w-full">
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={processImg02} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>Personal Info</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={processImg03} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>Written and oral English proficiency test</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={processImg04} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>Remote Interviews with Recruiters and Accounts representatives</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={processImg05} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>Complete aditional tests</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={processImg06} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>Send required documentation for hiring process</p>
					</div>
				</div>
				<div className="flex flex-col lg:flex-row w-full">
					<div className='flex flex-col w-full lg:w-2/5 justify-center items-center p-10 lg:pt-0 lg:pl-20'>
						<p className='text-telus-purple'>These are the stages of the process you will go through once you receive the link to online applications</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center p-10 pt-0 text-center'>
						<Img src={processImg07} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>A computer with internet connection to access the platform</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center p-10 pt-0 text-center'>
						<Img src={processImg08} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>A cell phone or computer to receive the call for the English test</p>
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center p-10 pt-0 text-center'>
						<Img src={processImg09} className='w-8/12 pb-4' />
						<p className='text-telus-dark text-base font-HelveticaNeueLTStd-Roman'>A keyboard for the typing test</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Recruitment;
